import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=5e36075f"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"
import style0 from "./NotificationView.vue?vue&type=style&index=0&id=5e36075f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports